import { Component, OnInit } from '@angular/core';
import { ExternalApisService } from 'src/app/services/external-apis.service';

@Component({
  selector: 'app-left-side',
  templateUrl: './left-side.component.html',
  styleUrls: ['./left-side.component.css']
})
export class LeftSideComponent implements OnInit {
  public theHtmlString ="";
  numberTrivia: number;
  numberTriviaText: string = "";
  retItem: any;
  retItems: any;
  constructor(private externalApis: ExternalApisService) { 

  }

  ngOnInit() {

  //  this.route.params.subscribe( params => {console.log(params);
      this.getNorrisJoke();
  //    this.getRandomNumberTrivia();
 //   });


  }


  getNorrisJoke() {
    
    this.externalApis.getNorrisJoke().subscribe((data) => {
      this.retItem = data;
      // console.log(this.retItem);
      //   this.theHtmlString = this.retItem.html_content;
    }), 
    err => {
         console.log(err);
      }
  }
  getRandomNumber(){
    var max = 500;
    return Math.floor(Math.random() * Math.floor(max));

  }
  getRandomNumberTrivia(){
    var num = this.getRandomNumber();
    this.numberTrivia = num;
    this.externalApis.getNumberTrivia(num).subscribe((data) => {
      this.numberTriviaText = data;
      // console.log(this.retItem);
      //   this.theHtmlString = this.retItem.html_content;
    }), 
    err => {
         console.log(err);
      }
  }
}
